export const VERSION = "2.1.1";
//# sourceMappingURL=version.js.map